import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Check } from 'lucide-vue-next';
    import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
    import { Voucher } from '@/types';
    import { computed } from 'vue';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import { useVoucherStore } from '@/stores/voucher';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BulkApproveVouchers',
  props: {
    selectedVouchers: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const voucherStore = useVoucherStore();

    const props = __props;

    const isValidVoucher = (voucher: Voucher) =>
        !voucher.uploaded && (voucher.has_voucher || voucher.is_valid_no_file);

    const validVouchers = computed(() => props.selectedVouchers.filter(isValidVoucher));

    const invalidVouchers = computed(() =>
        props.selectedVouchers.filter((voucher) => !isValidVoucher(voucher)),
    );

    const approve = () => {
        if (invalidVouchers.value.length) {
            toast.error(t('vouchers.select.upload.invalid_header'), {
                description: t('vouchers.select.upload.invalid_description', {
                    body: invalidVouchers.value
                        .map((voucher) => `#${voucher.VoucherNumber}`)
                        .join(', '),
                }),
            });
            return;
        }

        voucherStore.setValidVouchers(validVouchers.value);
        voucherStore.toggleOpen('approve', true);
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DropdownMenuItem), { onClick: approve }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('vouchers.select.approve')) + " ", 1),
      _createVNode(_unref(Check), { class: "text-accent" })
    ]),
    _: 1
  }))
}
}

})